// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48d79876","453":"310b6d3f","732":"a35d1201","977":"43bb98b4"}[chunkId] + ".chunk.js";
};